import React from 'react';
import {
 ConnectionForm
} from './ConnectionForm';
import {
 useNavigate, useLocation
} from 'react-router-dom';
import {
 Card, CardContent
} from 'shared/components/ui/card';

export const ConnectionFormPage: React.FC = () => {
  const navigate = useNavigate();
  const location = useLocation();

  return (
      <div className="w-full h-screen flex items-center justify-center">
          <Card className="w-full h-full shadow-lg border border-white/20 rounded-none">
              <CardContent className="w-full h-full p-4 overflow-auto">
                  <div className="w-full h-full">
                      <ConnectionForm
                              onConnectionSaved={() => navigate(location.pathname.replace(/\/new$/, ''))}
                              onCancel={() => navigate(location.pathname.replace(/\/new$/, ''))}
                              editingConnection={null}
                            />
                  </div>
              </CardContent>
          </Card>
      </div>

  );
};
